import React from "react";
import { FaChevronLeft } from "react-icons/fa";

const LeftIcon = () => (
  <FaChevronLeft
    style={{
      margin: "3px 5px -2px",
    }}
  />
);
export default LeftIcon;
